import { api } from './api'

// Returns all authors as [{ _id, label }].
export function listAuthors() {
  return api.get('/authors').then((data) => data.authors)
}
